import React, {Component} from 'react'
import ReactDOM from 'react-dom';
import { DragDropContext, DropTarget } from 'react-dnd';
import HTML5Backend, { NativeTypes } from 'react-dnd-html5-backend';
import withDragDropContext from './../../../../helpers/withDragDropContext';
import update from 'react-addons-update';
import MediaSidebar from './MediaSidebar'
import MediaPageNav from './MediaPageNav'
import MediaTopBar from './MediaTopBar'
import MediaList from './MediaList'
import FolderBrowse from './FolderBrowse'

const mediaDropTarget = {
  drop(props, monitor, component){
    var files = monitor.getItem().files
    for (var i = 0; i < files.length; i++) {
      component.mediaUploadActions(files[i])
    }
  }
}

class MediaManager extends Component {

  constructor(props) {
    super(props);

    this.state = {
      typeOfInput: this.props.type,
      typeOfMedia: this.props.type,
      pageNav: false,
      mediaItems: [],
      searchText: '',
      filters:[],
      filtered: '',
      activeItem: ''
    }

    this.liveSearchTimer = 0;
  }

  componentDidMount() {
    let queryData = {
      type: this.state.typeOfMedia,
    };
    var mediaList = this.getMediaItems(queryData);

    this.setState({
      mediaItems: mediaList.items,
      pageNav: mediaList.pageNav,
      filters: mediaList.filters
    })
  }

  handleSearchText(textInput) {
    let txtInput = textInput.trim();

    var queryData = {
        type: this.state.typeOfMedia,
        date: this.state.filtered,
        search: txtInput
    };

    if (this.liveSearchTimer) {
      clearTimeout(this.liveSearchTimer);
    }

    this.liveSearchTimer = setTimeout(function(){
      var mediaList = this.getMediaItems(queryData);

      this.setState({
        mediaItems: mediaList.items,
        pageNav: mediaList.pageNav,
        filters: mediaList.filters,
        searchText: txtInput
      })
    }.bind(this),300)
  }

  handlePageNavClick(e){
    e.preventDefault();

    let itemLenght = this.state.mediaItems.length
    let queryData = {
      type: this.state.typeOfMedia,
      date: this.state.filtered
    };

    if (this.state.searchText != '') {
      queryData.search = this.state.searchText
    }

    if ( itemLenght > 0) {
      queryData.start = itemLenght;
    }

    var mediaList = this.getMediaItems(queryData);

    this.setState({
      mediaItems: update(this.state.mediaItems, {$push: mediaList.items}),
      pageNav: mediaList.pageNav
    })
  }

  handleCategoryChange(mediaType){
    let queryData = {
      type: mediaType
    };

    if (mediaType == 'folders') {
      queryData.path = sppbMediaPath;
    }
    let mediaList = this.getMediaItems(queryData);

    if (mediaType =='folders') {
      this.setState({
        mediaItems: mediaList.images,
        filters: mediaList.folders,
        folders: mediaList.folders_list,
        typeOfMedia: mediaType,
        pageNav: '',
        activeItem: '',
        searchText: '',
        filtered: sppbMediaPath
      })
    } else {
      this.setState({
        typeOfMedia: mediaType,
        mediaItems: mediaList.items,
        filters: mediaList.filters,
        pageNav: mediaList.pageNav,
        activeItem: '',
        searchText: '',
        filtered: ''
      })
    }

  }

  filterChange(filter){
    let queryData = {
      type: this.state.typeOfMedia
    };

    if (this.state.typeOfMedia != 'folders') {
      queryData.date = filter;
    }else{
      queryData.path = filter;
    }

    var mediaList = this.getMediaItems(queryData);

    if (queryData.type =='folders') {
      this.setState({
        mediaItems: mediaList.images,
        folders: mediaList.folders_list,
        pageNav: '',
        activeItem: '',
        searchText: '',
        filtered: filter
      })
    } else {
      this.setState({
        mediaItems: mediaList.items,
        pageNav: mediaList.pageNav,
        activeItem: '',
        searchText: '',
        filtered: filter
      })
    }
  }

  getMediaItems( queryData ){
    let generateUrl = pagebuilder_base + 'index.php?option=com_sppagebuilder&view=media&layout=browse&format=json&source=page';
    let content;

    if (queryData.type == 'folders') {
        generateUrl = pagebuilder_base + 'index.php?option=com_sppagebuilder&view=media&layout=folders&format=json&source=page';
    }

    jQuery.ajax({
      type: 'POST',
      url: generateUrl,
      data: queryData,
      dataType: 'json',
      cache: false,
      async: false,
      success: function(response) {
        content = response;
        jQuery('.active-action-spinner').removeClass('active-action-spinner');
      }
    });

    return content;
  }

  handleActiveItem(item){
    this.setState({
      activeItem: item
    })
  }

  insertMediaClick(){
    this.props.onHandleInsertMedia(this.state.activeItem)
  }

  handleDeleteItem(){
    let message;

    jQuery.ajax({
      type: 'POST',
      url: pagebuilder_base + 'index.php?option=com_sppagebuilder&task=media.delete_media',
      data: { id: this.state.activeItem.id },
      dataType: 'json',
      cache: false,
      async: false,
      success: function(response) {
        message = response;
      }
    });

    if (!message.status) {
      alert(message.output);
      return;
    }

    this.setState({
      mediaItems: this.state.mediaItems.filter((item, i) => item.id !== this.state.activeItem.id),
      activeItem: ''
    })
  }

  handleUpload(files){
    this.mediaUploadActions(files);
  }

  mediaUploadActions(files){
    var formdata = new FormData();
    formdata.append('file', files);

    if (this.state.typeOfMedia == 'folders') {
      formdata.append('folder', this.state.filtered);
    }

    var result,
        that = this;

    jQuery.ajax({
      type: 'POST',
      url: pagebuilder_base + 'index.php?option=com_sppagebuilder&task=media.upload_media',
      data: formdata,
      contentType: false,
      cache: false,
      processData:false,
      beforeSend: function(){
        jQuery('.sp-pagebuilder-media-file-loader').css({display:'inline-block'})
      },
      xhr: function() {
        var myXhr = jQuery.ajaxSettings.xhr();
        myXhr.upload.onprogress = function(evt) {
          jQuery('.sp-pagebuilder-progress-bar').css('width', Math.floor(evt.loaded / evt.total *100) + '%').text(Math.floor(evt.loaded / evt.total *100) + '%');
        };
        return myXhr;
      }
    }).done(function(response){

      var result = jQuery.parseJSON(response);

      if (result.status) {
        delete result.output
      }else{
        alert(result.output);
      }

      jQuery('.sp-pagebuilder-media-file-loader').hide();

      if (result.status) {
        delete result.status

        that.setState({
          mediaItems: update(that.state.mediaItems,{
            $splice: [
              [0,0,result]
            ]
          })
        })
      }

    }).fail(function(response){
      var result = jQuery.parseJSON(response);
      alert(result.output);
    });
  }

  createFolder(folder){
    this.setState({
      filters: update(this.state.filters,{
        $push: [folder]
      }),
      folders: update(this.state.folders,{
        $splice: [
          [0,0,folder.name]
        ]
      })
    })
  }

  render(){
      const { connectDropTarget, isOver } = this.props

      var emptyMediaListClass = 'sp-pagebuilder-media-empty'
      var mediaListClass = 'sp-pagebuilder-media-wrapper'

      if (isOver) {
        emptyMediaListClass += ' show-sp-pagebuilder-media'
        mediaListClass += ' hide-sp-pagebuilder-media'
      }

    return(connectDropTarget(
      <div className="sp-pagebuilder-media-modal-inner">
        <div className="sp-pagebuilder-media-modal-sidebar">
          <MediaSidebar
            onHandleCategoryChange = { this.handleCategoryChange.bind(this) }
            browserMediaType={ this.state.typeOfMedia }
          />
        </div>
        <MediaTopBar
          activeItem = { this.state.activeItem }
          filters = { this.state.filters }
          filtered = { this.state.filtered }
          typeOfMedia = { this.state.typeOfMedia }
          searchText = { this.state.searchText }
          onHandleItemClick = {this.handleActiveItem.bind(this)}
          onInsertMediaClick = { this.insertMediaClick.bind(this) }
          onModalCloseClick = { this.props.onHandleMediaModal.bind(this) }
          onFilterChange = { this.filterChange.bind(this) }
          onHandleUpload = { this.handleUpload.bind(this) }
          onHandleDeleteItem = { this.handleDeleteItem.bind(this) }
          onHandleSearchText = { this.handleSearchText.bind(this) }
          onCreateFolder = { this.createFolder.bind(this) }
        />
        <div className="sp-pagebuilder-media-modal-body">
          <div className="sp-pagebuilder-media-modal-body-inner">
            <div className="sp-pagebuilder-media-list clearfix">
              <div className={emptyMediaListClass}>
                <div>
                  <i className="fa fa-upload"></i>
                  <h3 className="sp-pagebuilder-media-empty-title">Drag &amp; Drop files to upload.</h3>
                </div>
              </div>
              <div className={mediaListClass}>
                {
                  this.state.typeOfMedia == 'folders'
                  ?
                  <FolderBrowse
                    items = { this.state.mediaItems }
                    folders = { this.state.folders }
                    filtered = { this.state.filtered }
                    onFilterChange = { this.filterChange.bind(this) }
                    onHandleItemClick = { this.handleActiveItem.bind(this) }
                    activeItem = { this.state.activeItem }
                  />
                  :
                  <MediaList
                    items={ this.state.mediaItems }
                    supported={ this.state.typeOfInput }
                    onHandleItemClick = { this.handleActiveItem.bind(this) }
                    activeItem = { this.state.activeItem }
                  />
                }
                { this.state.pageNav == 'true' && <MediaPageNav onHandlePageNavClick={this.handlePageNavClick.bind(this)} /> }
              </div>
            </div>
          </div>
        </div>
      </div>
    ))
  }
}

var DropTargetDecorator = DropTarget(NativeTypes.FILE, mediaDropTarget,
  function(connect, monitor) {
    return {
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver()
    };
  }
);

export default withDragDropContext(DropTargetDecorator(MediaManager));



// WEBPACK FOOTER //
// ./src/helpers/form/types/media-helper/MediaManager.js